
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  inject,
  watch
} from "vue";
import { StepperComponent } from "@/assets/ts/components";
import { useRouter, useRoute } from "vue-router";
import { useForm } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import courtOrder from "@/views/filiation/registerFormSteps/registerCourtOrder.vue";
import personData from "@/views/filiation/registerFormSteps/personData.vue";
import checkReEntry from "@/views/filiation/registerFormSteps/checkReentry.vue";
import generalData from "@/views/filiation/registerFormSteps/generalData.vue";
import familyData from "@/views/filiation/registerFormSteps/familyData.vue";
import deseaseData from "@/views/filiation/registerFormSteps/deseaseData.vue";
import picturesData from "@/views/filiation/registerFormSteps/picturesData.vue";
import confirmationSend from "@/views/filiation/registerFormSteps/confirmationSend.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import filiation from "@/filiation/composables/useFiliation";
interface IStep0 {
  fecha_mandamiento: string;
  fecha_ingreso: string;
  anios_sentencia: unknown;
  meses_sentencia: unknown;
  fecha_salida: unknown;
  habilitarFechaSalida: boolean;
  tipo_mandamiento: string;
  nombre_juez: string;
  nombre_juzgado: string;
  tipo_juzgado: string;
  codigo_mandamiento: string;
  tipo_codigo: string;
  centro_penitenciario: string;
  // eslint-disable-next-line
  delitos: any;
  // eslint-disable-next-line
  seguido_por: any;
  es_requerido_relacion:boolean,
  relacion_posible_victima:string,
  nombre_relacion_no_aplica:string,
  es_requerido_nombre_relacion_no_aplica:boolean,
  observacionOrdenes: string;
  estado: boolean;
}
interface IStep1 {
  tipo: string;
  numero_documento: string;
  complemento: string;
  fotografia: string;
  nombres: string;
  primerApellido: string;
  segundoApellido: string;
  fecha_nacimiento: string;
  genero: string;
  pais: string;
  departamento: string;
  provincia: string;
  municipio: string;
  domicilio: string;
  telefonoFijo: string;
  telefonoCelular: string;
  observacionPersona: string;
}
interface IStep2 {
  family: string;
}

interface IStep3 {
  codigo_unico: string;
  estado_civil: string;
  identificacion_etnica: string;
  idioma_primario: string;
  idioma_secundario: string;
  orientacion_sexual: string;
  religion: string;
  profesion: string;
  oficio: string;
  grado_instruccion: string;
  observacionGenerales: string;
}

interface IStep4 {
  family: string;
}

interface IStep5 {
  desease: string;
}
interface IStep6 {
  frente: string;
  derecha: string;
  izquierda: string;
}
interface IStep7 {
  frente: string;
  derecha: string;
  izquierda: string;
}

interface CreateAccount
  extends IStep0,
    IStep1,
    IStep2,
    IStep3,
    IStep4,
    IStep5,
    IStep6,
    IStep7 {}

export default defineComponent({
  name: "registerForm",
  components: {
    courtOrder,
    personData,
    checkReEntry,
    generalData,
    familyData,
    deseaseData,
    picturesData,
    confirmationSend,
    //Step5,
  },
  setup() {
    const {
      sendForm,
      kardex,
      resetStatus,
      dataToEdit,
      sendEdition,
      posibleOrder,
    } = filiation();
    const emitter: any = inject("emitter");
    const checkIfExist = async () => {
      await posibleOrder(formData.value);
      emitter.emit("checkIfExist", true);
    };
    const router = useRouter();
    const route = useRoute();
    const sendDelay = ref(false);
    const _stepperObj = ref<StepperComponent | null>(null);
    const horizontalWizardRef = ref<HTMLElement | null>(null);
    const currentStepIndex = ref(0);
    const formData = ref<CreateAccount>({
      //Registro orden judicial
      fecha_mandamiento: "",
      fecha_ingreso: "",
      anios_sentencia: null,
      meses_sentencia: null,
      fecha_salida: "",
      habilitarFechaSalida: false,
      tipo_mandamiento: "",
      nombre_juez: "",
      nombre_juzgado: "",
      tipo_juzgado: "",
      codigo_mandamiento: "",
      tipo_codigo: "",
      centro_penitenciario: "",
      delitos: null,
      seguido_por: null,
      es_requerido_relacion: false,
      relacion_posible_victima:"",
      nombre_relacion_no_aplica:"",
      es_requerido_nombre_relacion_no_aplica:false,
      estado: false,
      //Datos de la pesona
      tipo: "",
      numero_documento: "",
      complemento: "",
      fotografia: "",
      nombres: "",
      primerApellido: "",
      segundoApellido: "",
      fecha_nacimiento: "",
      genero: "",
      pais: "",
      departamento: "",
      provincia: "",
      municipio: "",
      domicilio: "",
      telefonoFijo: "",
      telefonoCelular: "",
      observacionPersona: "",
      //generalData
      codigo_unico: "",
      estado_civil: "",
      identificacion_etnica: "",
      idioma_primario: "",
      idioma_secundario: "",
      orientacion_sexual: "",
      religion: "",
      profesion: "",
      oficio: "",
      grado_instruccion: "",
      observacionGenerales: "",
      family: "",
      desease: "",
      frente: "",
      derecha: "",
      izquierda: "",
      observacionOrdenes: "",
    });
    const printKardex = async (id) => {
      await kardex(id);
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    const tipo = ref("");
    onMounted(() => {
      _stepperObj.value = StepperComponent.createInsance(
        horizontalWizardRef.value as HTMLElement
      );
      personDetails.value !== "0"
        ? (tipo.value = "Edición")
        : (tipo.value = "Registro");
      setCurrentPageBreadcrumbs(`${tipo.value} de privado de libertad`, [
        "Privado de libertad",
      ]);
    });
    onUnmounted(() => {
      localStorage.removeItem("edit");
      resetStatus();
    });
    const createAccountSchema = [
      //courtOrderData
      Yup.object({
        fecha_mandamiento: Yup.string()
          .nullable()
          .required("La fecha de mandamiento es requerida."),
        fecha_ingreso: Yup.string()
          .nullable()
          .required("La fecha de ingreso es requerida."),
        tipo_mandamiento: Yup.string()
          .nullable()
          .required("el tipo de mandamiento es requerido."),
        anios_sentencia: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .when("tipo_mandamiento", {
            //para que años de sentencia no sea requerido en las opciomes diferentes de SENTENCIADO el id_tipo_mandamiento debe ser el que va en tipo == 1
            is: (tipo_mandamiento) => tipo_mandamiento == "1",
            then: Yup.number()
              .typeError("Debe ingresar un número de 1 a 30 (años)")
              .nullable()
              .min(1, "Debe ingresar al menos 1 (año)")
              .max(30, "Debe ingresar como máximo 30 (años)")
              .required("Los años de sentencia son requeridos."),
          }),
        meses_sentencia: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .when("tipo_mandamiento", {
            //para que meses de sentencia no sea requerido en las opciomes diferentes de SENTENCIADO el id_tipo_mandamiento debe ser el que va en tipo == 1
            is: (tipo_mandamiento) => tipo_mandamiento == "1",
            then: Yup.number()
              .typeError("Debe ingresar un número de 0 a 11 (meses)")
              .nullable()
              .min(0, "Debe ingresar al menos 0 (meses)")
              .max(11, "Debe ingresar como máximo 11 (meses)")
              .required("Los meses de sentencia son requeridos."),
          }),
        fecha_salida: Yup.string().when("tipo_mandamiento", {
          //para que fecha_salida no sea requerido en las opciomes diferentes de SENTENCIADO el id_tipo_mandamiento debe ser el que va en tipo == 1
          is: (tipo_mandamiento) => tipo_mandamiento == "1",
          then: Yup.string()
            .nullable()
            .required("La fecha de salida es requerida."),
        }),
        nombre_juez: Yup.string()
          .nullable()
          .required("El nombre del juez es requerido."),
        nombre_juzgado: Yup.string()
          .nullable()
          .required("El nombre del juzgado es requerido."),
        tipo_juzgado: Yup.string()
          .nullable()
          .required("El tipo de juzgado es requerido."),
        codigo_mandamiento: Yup.string()
          .nullable()
          .required("el código de mandamiento es requerido."),
        tipo_codigo: Yup.string()
          .nullable()
          .required("El tipo de código es requerido."),
        centro_penitenciario: Yup.string()
          .nullable()
          .required("El nombre del centro penitenciario es requerido."),
        delitos: Yup.array()
          .min(1, "El o los delitos son requeridos.")
          .nullable(),
        es_requerido_relacion: Yup.boolean(),
        relacion_posible_victima: Yup.string()
          .when('es_requerido_relacion', {
            is: true,
            then: Yup.string().required('La relación con la supuesta victima es requerida'),
            otherwise: Yup.string().notRequired()
          }),
        es_requerido_nombre_relacion_no_aplica:Yup.boolean(),
        nombre_relacion_no_aplica : Yup.string()
          .when('es_requerido_nombre_relacion_no_aplica', {
            is: true,
            then: Yup.string().required('La descripción de otra relación es requerida'),
            otherwise: Yup.string().notRequired()
          }),
      }),

      //personData
      Yup.object({
        tipo: Yup.string().required("El tipo de documento es requerido."),
        numero_documento: Yup.string()
          .nullable()
          .when("tipo", {
            //para que número de documento no sea requerido en la opción NO PORTA el id_tipo_documento_identidad debe ser el que va en tipo != 4
            is: (tipo) => tipo != 4,
            then: Yup.string()
              .nullable()
              .required("El número de documento es requerido."),
          }),
        nombres: Yup.string().nullable().required("El nombre es requerido."),
        segundoApellido: Yup.string()
          .nullable()
          .required("El apellido es requerido."),
        fecha_nacimiento: Yup.string().required(
          "La fecha de nacimiento es requerida."
        ),
        genero: Yup.string().required("El genero es requerido."),

        pais: Yup.string().required("El país es requerido."),
        domicilio: Yup.string().required("El domicilio es requerido."),
      }),
      //check verification
      Yup.object({
        //deseases: Yup.string().required().label("Name On Card"),
      }),
      //generalData
      Yup.object({
        codigo_unico: Yup.string().required("El código es requerido."),
        estado_civil: Yup.string()
          .nullable()
          .required("El estado civil es requerido."),
        identificacion_etnica: Yup.string()
          .nullable()
          .required("La identificación étnica es requerida."),
        idioma_primario: Yup.string()
          .nullable()
          .required("El idioma primario es requerido."),
        idioma_secundario: Yup.string()
          .nullable()
          .required("El idioma secundario es requerido."),
        orientacion_sexual: Yup.string()
          .nullable()
          .required("La orientación sexual es requerida."),
        religion: Yup.string().nullable().required("La religión es requerida."),
        profesion: Yup.string()
          .nullable()
          .required("La profesión es requerida."),
        oficio: Yup.string().nullable().required("el oficio es requerido."),
        grado_instruccion: Yup.string()
          .nullable()
          .required("El grado de instrucción es requerido."),
      }),
      Yup.object({
        //family: Yup.string().required().label("Name On Card"),
      }),
      Yup.object({
        //deseases: Yup.string().required().label("Name On Card"),
      }),
      Yup.object({
        frente: Yup.string()
          .nullable()
          .required("La foto de perfíl frontal es requerida."),
        derecha: Yup.string()
          .nullable()
          .required("La foto de perfíl derecho es requerida."),
        izquierda: Yup.string()
          .nullable()
          .required("La foto de perfíl izquierdo es requerida."),
      }),
    ];

    const currentSchema = computed(() => {
      return createAccountSchema[currentStepIndex.value];
    });
    const { resetForm, handleSubmit } = useForm<
      IStep0 | IStep1 | IStep2 | IStep3 | IStep4 | IStep5 | IStep6 | IStep7
    >({
      validationSchema: currentSchema,
    });

    const totalSteps = computed(() => {
      if (!_stepperObj.value) {
        return;
      }

      return _stepperObj.value.totatStepsNumber;
    });

    resetForm({
      values: {
        ...formData.value,
      },
    });

    const handleStep = handleSubmit((values) => {
      formData.value = {
        ...formData.value,
        ...values,
      };

      currentStepIndex.value++;

      if (!_stepperObj.value) {
        return;
      }

      _stepperObj.value.goNext();
    });

    const previousStep = () => {
      if (!_stepperObj.value) {
        return;
      }

      currentStepIndex.value--;

      _stepperObj.value.goPrev();
    };

    const formSubmit = async () => {
      sendDelay.value = true;
      // console.log("formData.value", formData.value);
      const { data } = await sendForm(formData.value);
      if (data.ok) {
        Swal.fire({
          title: "Registrado",
          text: "La persona Privada de libertad fue registrada exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(async () => {
          //window.location.reload();
          sendDelay.value = false;
          resetForm();
          router.push({ name: "listDeprivedLibertybyPrisons" });
          await printKardex(data.id_persona);
        });
      } else {
        Swal.fire({
          title: "Atención",
          text: "La filiación no pudo realizarse debido a que la persona ya se encuentra registrada.",
          icon: "info",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        sendDelay.value = false;
      }
    };
    const SendEdition = async () => {
      sendDelay.value = true;
      const params = {
        id_person: personDetails.value,
        id_order: orderDetails.value,
      };
      const { data } = await sendEdition({
        dato: formData.value,
        params: params,
      });
      if (data.ok) {
        Swal.fire({
          title: "Editado",
          text: `${data.message}`,
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(async () => {
          //window.location.reload();
          sendDelay.value = false;
          resetForm();
          router.push({ name: "listDeprivedLibertybyPrisons" });
          await printKardex(data.id_persona);
        });
      } else {
        Swal.fire({
          title: "Atención",
          text: "La edición no pudo realizarse favor contactese con el administrador.",
          icon: "info",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        sendDelay.value = false;
      }
    };
    return {
      sendDelay,
      dataEdit,
      tipo,
      horizontalWizardRef,
      personDetails,
      previousStep,
      handleStep,
      formSubmit,
      SendEdition,
      printKardex,
      totalSteps,
      currentStepIndex,
      checkIfExist,
    };
  },
});
